import * as React from "react";

import { Redirect, Router } from "@reach/router";

import { AppLayoutType } from "kw/components/AppLayout/AppLayout";
import { AutoQuote } from "./pages/AutoQuote";
import { Error404Page } from "kw/quoting/pages/Error404Page";
import { GlobalsContext } from "kw/util/Globals";
import { KnockoutFlowPage } from "./pages/KnockoutFlowPage";
import { PasswordLessUserRegisterPage } from "./pages/PasswordLessUserRegisterPage";
import { PaymentPage } from "./pages/PaymentPage";
import { PolicyConfirmationPage } from "./pages/PolicyConfirmationPage";
import { PolicyHolderFlowPage } from "./pages/PolicyHolderFlowPage";
import { Quote } from "./pages/Quote";
import { QuoteFlowPage } from "./pages/QuoteFlowPage";
import { ReferralPage } from "./components/ReferralPage";
import { RouterOutlet } from "kw/components/RouterOutlet/RouterOutlet";

export function QuotingMain() {
  return (
    <GlobalsContext.Provider value="quoting">
      <Router basepath="/">
        <Error404Page default />
        <Redirect path="/" from="/" to="/getquote" noThrow />
        <Redirect path="/quote" from="/quote" to="/quote/ready" noThrow />
        <RouterOutlet
          component={ReferralPage}
          path="/quote/referral/:riskProfileId/*"
        />
        <RouterOutlet component={QuoteFlowPage} path="/getquote/*" />
        <RouterOutlet component={QuoteFlowPage} path="/quoting/:riskProfileId/*" />
        <RouterOutlet
          component={Quote}
          path="/quote/ready/*"
          layoutOverrides={{ layoutType: AppLayoutType.Progress }}
        />
        <RouterOutlet
          component={KnockoutFlowPage}
          path="/quoting/knockout/:riskProfileId/*"
        />
        <RouterOutlet
          component={PolicyHolderFlowPage}
          path="/quoting/policyholders/:riskProfileId/*"
        />
        <RouterOutlet
          component={PasswordLessUserRegisterPage}
          path="/quoting/:riskProfileId/password-less-register"
        />
        <RouterOutlet component={PaymentPage} path="/quoting/payment/:riskProfileId" />
        <RouterOutlet
          component={PolicyConfirmationPage}
          path="/policy/:riskProfileId/confirmed"
          layoutOverrides={{
            layoutType: AppLayoutType.Progress,
            showHeader: true,
          }}
        />
        <RouterOutlet
          component={AutoQuote}
          path="/autoquote"
          layoutOverrides={{
            layoutType: AppLayoutType.Empty,
          }}
        />
      </Router>
    </GlobalsContext.Provider>
  );
}
